<dt class="hvac-product-property-list-item-label hvac-p-sm hvac-fw-sb"><ng-content></ng-content>
</dt>
